var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcInfo = function SvgIcInfo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_872_11027",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12C3 7.00909 7.00909 3 12 3C16.9909 3 21 7.00909 21 12C21 16.9909 16.9909 21 12 21C7.00909 21 3 16.9909 3 12ZM4.63647 12C4.63647 16.0909 7.9092 19.3636 12.0001 19.3636C16.091 19.3636 19.3637 16.0909 19.3637 12C19.3637 7.9091 16.091 4.63637 12.0001 4.63637C7.9092 4.63637 4.63647 7.9091 4.63647 12ZM12.8182 12V15.2727C12.8182 15.7636 12.4909 16.0909 12 16.0909C11.5091 16.0909 11.1818 15.7636 11.1818 15.2727V12C11.1818 11.5091 11.5091 11.1818 12 11.1818C12.4909 11.1818 12.8182 11.5091 12.8182 12ZM12.8182 8.72727C12.8182 8.48182 12.7364 8.31818 12.5727 8.15455C12.4091 7.99091 12.0818 7.90909 11.8364 7.90909C11.7893 7.95614 11.7693 7.97613 11.7453 7.98463C11.7275 7.99091 11.7075 7.99091 11.6727 7.99091C11.6318 7.99091 11.6114 8.01136 11.5909 8.03182C11.5705 8.05227 11.55 8.07273 11.5091 8.07273L11.4273 8.15455C11.2636 8.31818 11.1818 8.48182 11.1818 8.72727C11.1818 8.97273 11.2636 9.13636 11.4273 9.3C11.4273 9.3 11.4273 9.38182 11.5091 9.38182C11.55 9.38182 11.5705 9.40227 11.5909 9.42273C11.6114 9.44318 11.6318 9.46364 11.6727 9.46364C11.7198 9.51069 11.7398 9.53068 11.7638 9.53918C11.7816 9.54545 11.8016 9.54545 11.8364 9.54545H12C12.2455 9.54545 12.4091 9.46364 12.5727 9.3C12.7364 9.13636 12.8182 8.97273 12.8182 8.72727Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_872_11027)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#BDBDBD"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_info.07209fd730314f1e269305f0e300fe23.svg";